import { FORM_FIELDS } from '../../../../../../../../constants';
import { getValidationSchema } from '../../../../../../../form/common.validators';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.BIRTHDAY,
        FORM_FIELDS.BIRTH_PLACE,
        FORM_FIELDS.PASSPORT_NUMBER,
        FORM_FIELDS.PASSPORT_DATE,
        FORM_FIELDS.UNIT_CODE,
        FORM_FIELDS.ISSUED,
        FORM_FIELDS.REGISTRATION_STREET,
        FORM_FIELDS.REGISTRATION_DATE,
        FORM_FIELDS.RESIDENCE_STREET,
    ]);
